import React from 'react';
import cx from 'classnames';
import { oneOf, string, bool } from 'prop-types';

const CLASS_ROOT = 'input';

const propTypes = {
  size: oneOf(['large', 'small']),
  placeholder: string,
  isFilling: bool,
  value: string,
  tag: string,
  type: string,
  name: string,
};

const Input = ({
  className,
  children,
  size,
  placeholder,
  isFilling,
  value,
  tag = 'input',
  type = 'text',
  name,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
      [`${CLASS_ROOT}--filling`]: isFilling,
    },
    className,
  );

  const Tag = tag;

  return (
    <Tag
      type={type}
      name={name}
      value={value}
      placeholder={placeholder}
      className={classes}
      {...other}
    >
      {children}
    </Tag>
  );
};

Input.propTypes = propTypes;

export default Input;
